var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import formatEmail from '../../../helpers/formatEmail';
import isPlatformPeaks from '../../../helpers/isPlatformPeaks';
import { CLICK_TRACKING_EVENT, DATA_OBJECT, DATA_TYPE } from '../../../const/analytics';
import { useAlerts } from '../../customHooks';
import { ContactCard, ContactCardWrapper, ContactIconWrapper, ContactInfoWrapper, ContactInformationContainer, ContactLabel, ContactText, ContactTitle, ContactTitleWrapper, Icon, TextButton } from './subcomponents';
import { FAL_PHONE } from '../../../const/iconProps';
var RenderEmail = function (_a) {
    var value = _a.value;
    return (_jsx("p", __assign({ className: "contactData", "data-private": true }, { children: value })));
};
var LongEmailAddress = function (_a) {
    var username = _a.username, domain = _a.domain;
    return (_jsxs(_Fragment, { children: [_jsx(RenderEmail, { value: username }), _jsx(RenderEmail, { value: domain })] }));
};
var Email = function (_a) {
    var email = _a.email;
    var _b = formatEmail({
        emailAddress: email,
        allowedLength: 30
    }), isLongEmailAddress = _b[0], username = _b[1], domain = _b[2];
    return isLongEmailAddress ? (_jsx(LongEmailAddress, { domain: domain, username: username })) : (_jsx("p", __assign({ className: "contactData", "data-private": true }, { children: email })));
};
var ContactInformation = function () {
    var t = useTranslation().t;
    var _a = useAlerts(), _b = _a.appConfig, platform = _b.platform, handleProfileClick = _b.handleProfileClick, guid = _a.syfIdentifier, _c = _a.profileData, phone = _c.phone, email = _c.email;
    var isPeaks = isPlatformPeaks(platform);
    var CONTACT_INFO_TITLE = t('contactInformation.title');
    var CONTACT_INFO_BODY = t('contactInformation.content');
    var CONTACT_INFO_LINK = t('buttonLabels.updatePhoneOrEmail');
    var PHONE_LABEL = t('contactInformation.phoneTitle');
    var EMAIL_LABEL = t('contactInformation.emailTitle');
    var MISSING_PHONE = t('contactInformation.noPhoneNumberAvailable');
    return (_jsx(ContactCardWrapper, __assign({ "data-test": "ContactCardWrapper" }, { children: _jsxs(ContactCard, { children: [_jsxs(ContactTitleWrapper, { children: [_jsx(ContactIconWrapper, { children: _jsx(Icon, { icon: FAL_PHONE, size: "lg" }) }), _jsx(ContactTitle, { children: CONTACT_INFO_TITLE })] }), _jsxs(ContactInfoWrapper, { children: [_jsx(ContactText, { children: CONTACT_INFO_BODY }), email !== '' && (_jsxs(ContactInformationContainer, { children: [_jsxs("div", { children: [_jsx(ContactLabel, { children: PHONE_LABEL }), _jsx("p", __assign({ className: "contactData", "data-private": true }, { children: phone || MISSING_PHONE }))] }), _jsxs("div", { children: [_jsx(ContactLabel, { children: EMAIL_LABEL }), _jsx(Email, { email: email })] })] })), !isPeaks && (_jsx(TextButton, __assign({ buttonType: "text", onClick: function () { return handleProfileClick(guid); }, className: "ensightenalertevent", "data-type": DATA_TYPE.LINK, "data-reason": "update phone or email", "data-analytics": CLICK_TRACKING_EVENT, "data-object": DATA_OBJECT.LINK, "$isEmailAvailable": email !== '' }, { children: CONTACT_INFO_LINK })))] })] }) })));
};
export default ContactInformation;
